<template>
    <div v-if="show" class="UpdateOverlay">
        <div ref="content" class="UpdateOverlay-content">
            <div class="UpdateOverlay-text">
                <span class="UpdateOverlay-title"
                    >Neue Version verfügbar. Bitte aktualisieren Sie die App.</span
                >
            </div>
            <Button variant="success" @onClick="reloadPage"> Aktualisieren </Button>
        </div>
    </div>
</template>

<script>
import { gsap } from 'gsap';
import Button from '@/components/widgets/Button';

export default {
    name: 'UpdateOverlay',
    components: {
        Button,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        message: {
            type: String,
            default: 'Eine neue Version der App ist verfügbar.',
        },
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.animateIn();
                });
            } else {
                this.animateOut();
            }
        },
    },
    mounted() {
        if (this.show) {
            this.$nextTick(() => {
                this.animateIn();
            });
        }
    },
    beforeDestroy() {
        if (this.$refs.content) {
            gsap.killTweensOf(this.$refs.content);
        }
    },
    methods: {
        animateIn() {
            const content = this.$refs.content;
            if (!content) return;

            gsap.set(content, {
                y: 100,
                opacity: 0,
                scale: 0.8,
                force3D: true,
            });

            gsap.to(content, {
                y: 0,
                opacity: 1,
                scale: 1,
                duration: 0.6,
                ease: 'back.out(1.7)',
                force3D: true,
            });
        },
        animateOut() {
            const content = this.$refs.content;
            if (!content) return;

            gsap.to(content, {
                y: 100,
                opacity: 0,
                scale: 0.8,
                duration: 0.3,
                ease: 'power2.in',
                force3D: true,
            });
        },
        reloadPage() {
            window.location.reload();
        },
    },
};
</script>

<style lang="scss">
.UpdateOverlay {
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: 1000;
    pointer-events: auto;

    &-content {
        display: flex;
        align-items: center;
        gap: 12px;
        background: white;
        padding: 12px 16px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        min-width: 280px;
        max-width: 400px;
    }

    &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        color: var(--color-green, #10b981);
        flex-shrink: 0;

        i {
            font-size: 20px;
        }
    }

    &-text {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    &-title {
        font-size: 14px;
        font-weight: 500;
        color: var(--color-text-black, #1f2937);
        line-height: 1.4;
    }

    &-button {
        background: var(--color-green, #10b981);
        color: white;
        border: none;
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.2s ease;
        white-space: nowrap;
        flex-shrink: 0;

        &:hover {
            background: var(--color-green-dark, #059669);
        }

        &:active {
            transform: scale(0.98);
        }
    }
}
</style>
